"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "3",
    height: "5",
    viewBox: "0 0 3 5",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3899EC",
    d: "M.466 2.99L0 2.5l.31-.327L2.069.327 2.378 0 3 .653 2.69.98 1.242 2.5l1.446 1.52.311.327L2.379 5l-.311-.327L.466 2.99z"
  }));
};